import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CollapsableTitleInterface } from '../interfaces/Collapsable-title';

@Injectable({
  providedIn: 'root'
})
export class CategoriesStore {
  private readonly STORAGE_KEY = 'categories';
  private readonly _categories$: BehaviorSubject<CollapsableTitleInterface[] | null>;

  constructor() {
    let initialValue: CollapsableTitleInterface[] | null = null;
    try {
      const stored = sessionStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        initialValue = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error restoring categories from sessionStorage', e);
    }
    this._categories$ = new BehaviorSubject<CollapsableTitleInterface[] | null>(initialValue);
  }

  get categories$(): Observable<CollapsableTitleInterface[] | null> {
    return this._categories$.asObservable();
  }

  get categories(): CollapsableTitleInterface[] | null {
    return this._categories$.getValue();
  }

  set categories(value: CollapsableTitleInterface[] | null) {
    if (value) {
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(value));
    } else {
      sessionStorage.removeItem(this.STORAGE_KEY);
    }
    this._categories$.next(value);
  }
}
